import React, { useCallback, useMemo } from "react";
import { TrailModule } from "../../types/TrailModule";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";


export const TrailCard = ({ module }: Props) => {


    const goTo = useCallback(() => {
        window.open(module.link, '_blank');
    }, [module]);

    const replaceText = useMemo((): string => {

        const divClass = "text-blue-500 font-bold mx-1"
        let text = module.text;
        text = text.replaceAll("{","<span class='"+divClass+"'>")
        text = text.replaceAll("}","</span>")
        return text

    }, [module]);

    return (
        <div className="border-l-4 border-primary rounded-md">
            <div
                className="border-2 border-l-0 border-gray-300 p-4 rounded-md bg-white flex flex-col justify-between"
                style={{ minHeight: "182px" }}
            >

                    <div className=""
                        dangerouslySetInnerHTML={{
                            __html: replaceText,
                        }}
                    ></div>

                <div
                    className="self-end cursor-pointer text-blue-500 flex items-center font-semibold"
                    onClick={goTo}
                >
                    {module.link_name} <HiOutlineArrowNarrowRight />
                </div>
            </div>
        </div>
    );
};
interface Props {
    module: TrailModule;
}
